import { MentorshipCohortListItem } from './MentorshipService';

interface MentorshipCohortSelectorProps {
    cohorts: MentorshipCohortListItem[];
    selectedCohortId: number | null;
    isCreating: boolean;
    disabled?: boolean;
    onSelect: (cohortId: number | null) => void;
    onAddNew: () => void;
}

const MentorshipCohortSelector = ({
    cohorts,
    selectedCohortId,
    isCreating,
    disabled = false,
    onSelect,
    onAddNew,
}: MentorshipCohortSelectorProps) => {
    const hasCohorts = cohorts.length > 0;
    const selectValue = isCreating ? '' : selectedCohortId == null ? '' : String(selectedCohortId);

    return (
        <div className="d-flex flex-wrap align-items-end gap-3 mb-4">
            <div className="flex-grow-1" style={{ minWidth: 220 }}>
                <label className="form-label mb-1" htmlFor="mentorship-cohort-select">
                    Cohort
                </label>
                <select
                    id="mentorship-cohort-select"
                    className="form-select"
                    disabled={disabled}
                    value={selectValue}
                    onChange={(event) => {
                        const value = event.target.value;
                        onSelect(value ? Number(value) : null);
                    }}>
                    <option value="">{hasCohorts ? 'Select a cohort' : ''}</option>
                    {cohorts.map((cohort) => (
                        <option key={cohort.id} value={cohort.id}>
                            {cohort.name || `Cohort ${cohort.id}`}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <button type="button" className="btn btn-success" disabled={disabled} onClick={onAddNew}>
                    Add New Cohort
                </button>
            </div>
        </div>
    );
};

export default MentorshipCohortSelector;
